import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HospitalStructuredData from './components/StructuredData';
import Home from './pages/Home';
import Services from './pages/Services';
import Units from './pages/Units';
import Hierarchy from './pages/Hierarchy';
import UnitDetail from './pages/UnitDetail';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <HospitalStructuredData />
      <div className="App min-h-screen bg-warm-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/units" element={<Units />} />
            <Route path="/units/:unitId" element={<UnitDetail />} />
            <Route path="/hierarchy" element={<Hierarchy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
